import { useInfiniteQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

interface IProps {
  limit?: number;
  filters: {
    group_uid_ne?: string;
    nameContains?: string;
  };
}

export const useUsersQuery = ({ limit, filters }: IProps) => {
  return useInfiniteQuery({
    queryKey: ['getUsers', { limit, group_uid_ne: filters.group_uid_ne, nameContains: filters.nameContains }],
    queryFn: async ({ pageParam = 0 }) => {
      return await Api.users.getUsers({
        offset: pageParam,
        limit: limit || 0,
        group_uid_ne: filters.group_uid_ne,
        name__contains: filters.nameContains,
      });
    },
    getNextPageParam: (current, allPages) => {
      const count = allPages.length * (limit || 1);
      return count >= (current.total || 0) ? undefined : count;
    },
  });
};
